import {captionFontById} from '../../../../src/lib/caption-fonts';
import {loadFontFromTextItem} from '../../vendor/src/features/remotion-editor/editor/utils/text/load-font-from-text-item';
import type {CinematicMotion} from '../../protocol/cinematic-motion';
import {loadCinematicCaptionFont} from './cinematic-caption-font';
export async function prepareCinematicMotionFonts(data:CinematicMotion){
 const def=captionFontById(data.fontId);if(def.id!==data.fontId)throw new Error('그래픽 제목 글꼴을 다시 선택해 주세요.');
 const families=data.mode==='infographic'?['Pretendard','Noto Sans KR']:['Noto Sans KR'];
 const weights=data.mode==='infographic'?['500','600','700','800','900']:['600','800'];
 await Promise.all(families.flatMap(fontFamily=>weights.map(fontWeight=>loadFontFromTextItem({fontFamily,fontVariant:'normal',fontWeight,fontInfosDuringRendering:null}))));
 await loadCinematicCaptionFont(def);
}
